import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'

export default class ProposalCustomerFieldsLabelEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
  }

  handleSave = (customerFieldsLabel) => {
    const { onProposalUpdate, proposal } = this.props
    onProposalUpdate({ data: { ...proposal.data, customerFieldsLabel } })
  }

  render() {
    const { proposal } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Customer info heading">
          <TextInput
            required
            maxLength={128}
            multiline
            placeholder="Enter heading here..."
            defaultValue={proposal.data.customerFieldsLabel || ''}
            onSave={this.handleSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
